import React from 'react';
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { observer } from "mobx-react";
import { TextConstants } from "../../../Common/TextConstants";
import ManageInstrumentTypeComponent from "../Components/ManageInstrumentTypeComponent";
import InstrumentTypeLookup from "../Models/Lookups/InstrumentTypeLookup";
import InstrumentsVM from '../../Instruments/Views/InstrumentsVM';
import { InstrumentTypes } from '../../../AccessControl/Models/Commands/Security/Roles';

interface IInstrumentTypeComponentProps {
    viewModel: InstrumentsVM;
}

@observer
export default class InstrumentTypesComponent extends React.Component<IInstrumentTypeComponentProps> {

    public render() {
        const viewModel = this.props.viewModel;
        return (
            <>
                {viewModel.showManageInstrumentTypesComponent &&
                    <ManageInstrumentTypeComponent
                        viewModel={viewModel.manageInstrumentTypeVM}
                        onSave={() => viewModel.manageInstrumentTypeVM.instrumentTypeName === "" ?  viewModel.saveInstrumentType() : viewModel.saveInstrumentSubtype()}
                        onCancel={() => viewModel.cancelInstrumentType()} />
                }
                {!viewModel.showManageInstrumentTypesComponent &&
                    <Neo.Card title={TextConstants.Titles.InstrumentTypes} className="m-1">
                        {viewModel.authorisationService.hasRole(InstrumentTypes.AddNew) &&
                            <div className="row pb-3">
                                <div className="col text-right">
                                    <Neo.Button
                                        onClick={() => viewModel.addNewInstrumentType()}
                                        variant="primary" size="sm"
                                    >{TextConstants.Buttons.AddInstrumentType}</Neo.Button>
                                </div>
                            </div>
                        }
                        <>
                            <Neo.Form model={viewModel.instrumentTypeSearchCriteria} onSubmit={() => viewModel.instrumentTypeSearchCriteria.meta.searchCriteria.value === "" ? viewModel.instrumentTypesPageManager.refreshData() : viewModel.clearSearchInstrumentType()}>
                                <Neo.FormGroup
                                    suppressLabel={true}
                                    bind={viewModel.instrumentTypeSearchCriteria.meta.searchCriteria}
                                    placeholder={TextConstants.PlaceHolder.SearchInstrumentTypes}
                                    append={
                                        <Neo.Button className="btn-small" isSubmit variant="primary">
                                            <i className={`${viewModel.instrumentTypeSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                        </Neo.Button>
                                    } />
                            </Neo.Form>
                        </>
                        <>
                            <Neo.Pager pageManager={viewModel.instrumentTypesPageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                                <div className="horizontalScroll">
                                    {viewModel.instrumentTypesPageManager.totalRecords > 0 &&
                                        <NeoGrid.Grid<InstrumentTypeLookup> className={"table-striped"}>
                                            {(item, meta) => (
                                                <NeoGrid.RowGroup expandProperty={meta.isExpanded}>
                                                    <NeoGrid.Row>
                                                        <NeoGrid.Column display={meta.instrumentTypeName} />
                                                        {viewModel.authorisationService.hasRole(InstrumentTypes.Edit) &&
                                                            <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center" >
                                                                <Neo.Button
                                                                    onClick={() => viewModel.editInstrumentType(item)}
                                                                    variant="primary" isOutline className="btn-small">
                                                                    <i className="fa fa-edit"></i>
                                                                </Neo.Button>
                                                            </NeoGrid.ButtonColumn>
                                                        }
                                                    </NeoGrid.Row>
                                                    {<NeoGrid.ChildRow>
                                                        <NeoGrid.Grid
                                                            items={item.instrumentSubTypeList}
                                                            addButton={{
                                                                icon: "none",
                                                                size: "sm",
                                                                text: TextConstants.Buttons.AddInstrumentSubtype,
                                                                onClick: () => viewModel.addNewInstrumentSubtype(item.instrumentTypeName, item.staticInstrumentTypeID),
                                                                disabled: !viewModel.authorisationService.hasRole(InstrumentTypes.AddNew)
                                                            }}>
                                                            {(child, childMeta) => (
                                                                <NeoGrid.Row>
                                                                    <NeoGrid.Column display={childMeta.instrumentSubTypeName} label={TextConstants.Labels.InstrumentSubTypeName} />
                                                                    {viewModel.authorisationService.hasRole(InstrumentTypes.Edit) &&
                                                                        <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center">
                                                                            <Neo.Button
                                                                                onClick={() => viewModel.editInstrumentSubtype(item.instrumentTypeName, child)}
                                                                                variant="primary" isOutline className="btn-small">
                                                                                <i className="fa fa-edit"></i>
                                                                            </Neo.Button>
                                                                        </NeoGrid.ButtonColumn>
                                                                    }
                                                                </NeoGrid.Row>
                                                            )}
                                                        </NeoGrid.Grid>
                                                    </NeoGrid.ChildRow>
                                                    }
                                                </NeoGrid.RowGroup>
                                            )}
                                        </NeoGrid.Grid>
                                    }
                                </div>
                            </Neo.Pager>
                        </>
                    </Neo.Card>
                }
            </>
        )
    }
}